export const API_URL = process.env.REACT_APP_API_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION || "v1";

// Environment Configuration
export const ENV = process.env.REACT_APP_ENV || "development";
export const IS_DEVELOPMENT = ENV === "development";
export const IS_PRODUCTION = ENV === "production";

export const API_TIMEOUT = process.env.REACT_APP_API_TIMEOUT || 5000_000; //s

export const AN_ERROR_TRY_AGAIN = "An error occurred. Please try again!";

// Storage Keys
export const STORAGE_KEYS = {
  AUTH_STORAGE_KEY: process.env.REACT_APP_AUTH_STORAGE_KEY || "aSK",
  SESSION_ID_STORAGE_KEY: process.env.REACT_APP_SESSION_ID_STORAGE_KEY || "sIK",
  ACCESS_TOKEN: process.env.REACT_APP_ACCESS_TOKEN_KEY || "accessToken",
  END_USER_ACCESS_TOKEN:
    process.env.REACT_APP_END_USER_ACCESS_TOKEN_KEY || "endUserAccessToken",
  TENANT_DOMAIN: process.env.REACT_APP_TENANT_DOMAIN || "tenantDomain",
  TENANT_CODE: process.env.REACT_APP_TENANT_CODE || "tenantCode",
  USER: process.env.REACT_APP_USER_STORAGE_KEY || "user",
  CUSTOMER_ID: process.env.REACT_APP_CUSTOMER_ID_STORAGE_KEY || "customerId",
  REFERRAL_CODE_KEY: process.env.REACT_APP_REFERRAL_CODE_KEY || "referral_code",
  UTM_SOURCE_KEY: process.env.REACT_APP_UTM_SOURCE_KEY || "utm_source",
  IS_SHOPIFY: process.env.REACT_APP_IS_SHOPIFY || "isShopify",
  MANAGE_BILLING_MODAL:
    process.env.REACT_APP_MANAGE_BILLING_MODAL || "manage_billing_modal",
  PASSWORD_PROTECTED_TOKEN:
    process.env.REACT_APP_PASSWORD_PROTECTED_TOKEN_KEY ||
    "passwordProtectedToken",
} as const;

// Auth Headers
export const AUTH_HEADERS = {
  BEARER_PREFIX: process.env.REACT_APP_BEARER_PREFIX || "Bearer",
} as const;

// reCAPTCHA Configuration
export const RECAPTCHA_SECRET_KEY = process.env
  .REACT_APP_RECAPTCHA_SECRET_KEY as string;

export const RECAPTCHA_ENABLED = IS_PRODUCTION;

export const ADMIN_DOMAIN =
  process.env.REACT_APP_ADMIN_DOMAIN || "test.member.pixelboss.io";

export const SHOPIFY = {
  HOME_URL: process.env.REACT_APP_SHOPIFY_HOME_URL || "https://swiift.studio",
};

export const SHOPIFY_ADMIN_ORIGIN =
  process.env.REACT_APP_SHOPIFY_ADMIN_ORIGIN || "https://admin.shopify.com";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const auth0Config = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
};

export const googleConfig = {
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  fonts_api: process.env.REACT_APP_GOOGLE_FONTS_API,
};

export const linkedinConfig = {
  clientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
};

export const themeConfig = {
  embedScriptUrl: process.env.REACT_APP_EMBED_SCRIPT_URL,
};

// Shopify App Bridge Configuration
export const shopifyConfig = {
  apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
  forceRedirect: true,
};

export const externalUrls = {
  privatePolicyUrl: "https://swiift.io/privacy",
  termsOfUseUrl: "https://swiift.io/tnc",
  cookiePolicyUrl: "https://swiift.io/privacy",
};

export const REACT_APP_CMS_FE_DOMAIN =
  process.env.REACT_APP_CMS_FE_DOMAIN || "https://test.swiift.studio";
